import { Component, OnInit } from '@angular/core';
import { isDesktop } from '@libraries/ui-state';
import { select, Store } from '@ngrx/store';
import { checkAnotherProperty } from '../+state';

@Component({
  selector: 'property-not-eligible',
  templateUrl: './property-not-eligible.component.html',
  styleUrls: ['./property-not-eligible.component.scss'],
  standalone: false,
})
export class PropertyNotEligibleComponent implements OnInit {
  isDesktop$ = this.store.pipe(select(isDesktop));

  constructor(private store: Store) {}

  ngOnInit() {}

  navigate() {
    this.store.dispatch(checkAnotherProperty());
  }
}
